import axios from 'axios'
import getApiURL from '@utils/getApiURL'

const validateEmpRefCode = async (code) => {
  try {
    const response = await axios.get(`${getApiURL('empRefCode')}/empRefCode`, {
      params: { code },
    })
    return response.data
  } catch (error) {
    console.error(error.message)
    throw new Error(error.message)
  }
}

export default validateEmpRefCode
